import { useTranslation } from 'react-i18next';
import HotelPickerPage from './Partials/HotelPickerPage';
import AllotmentsEditor from './Partials/AllotmentsEditor';

export default function Allotments() {
  const { t } = useTranslation();

  return (
    <HotelPickerPage title={t('pages:allotments')} kind="allotments">
      {({ hotel }) => <AllotmentsEditor hotel={hotel} />}
    </HotelPickerPage>
  );
}
